import { render } from "./ConfigOrder.vue?vue&type=template&id=6a7a305c&scoped=true"
import script from "./ConfigOrder.vue?vue&type=script&lang=js"
export * from "./ConfigOrder.vue?vue&type=script&lang=js"

import "./ConfigOrder.vue?vue&type=style&index=0&id=6a7a305c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7a305c"]])

export default __exports__